import React from "react";
import PropTypes from "prop-types";
import { Row as AntRow } from "antd";

import "./Row.scss";

const GUTTER_MAP = {
  XXS: 4,
  XS: 8,
  S: 16,
  M: 24,
  L: 32,
  XL: 48,
  XXL: 64,
  XXXL: 96,
};

export class Row extends React.Component {
  static defaultProps = {
    justify: "center",
    align: "middle",
    wrap: true,
  };

  static propTypes = {
    /** Additional class names for the component */
    className: PropTypes.string,
    /** used to specify vertical alignment. */
    align: PropTypes.oneOf(["top", "middle", "bottom", "stretch"]),
    /** used to set spacing between grids, can be a number or an object or an array for both horizontal and vertical spacing. */
    gutter: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.oneOf(Object.keys(GUTTER_MAP))),
      PropTypes.oneOf(Object.keys(GUTTER_MAP)),
    ]),
    /** used to specify horizontal arrangement. */
    justify: PropTypes.oneOf([
      "start",
      "end",
      "center",
      "space-around",
      "space-between",
      "space-evenly",
    ]),
    /** used for automatic line wrapping. */
    wrap: PropTypes.bool,
  };

  mapGutter = (gutter) => {
    if (Array.isArray(gutter)) {
      return gutter.map((gutterItem) => GUTTER_MAP[gutterItem]);
    }

    return GUTTER_MAP[gutter];
  };

  render() {
    const { className, gutter, ...rowProps } = this.props;
    rowProps.gutter = this.mapGutter(gutter);

    return <AntRow className={className} {...rowProps} />;
  }
}

export default Row;
